import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/context/AuthContext";
import { useSites } from "@/context/SiteContext";
import Shell from "@/components/Shell";
import { Card } from "@/components/ui/card";
import { WarningOctagon, CheckCircle } from "@phosphor-icons/react";

export default function Alerts() {
  const { activeSiteId, siteParams } = useSites();
  const [summary, setSummary] = useState(null);
  useEffect(() => {
    axios.get(`${API}/reports/summary`, { params: siteParams() }).then(r => setSummary(r.data));
    // eslint-disable-next-line
  }, [activeSiteId]);

  const items = summary?.low_stock_items || [];

  return (
    <Shell title="Stok Uyarıları" subtitle="Kritik Seviye Altında">
      {items.length === 0 ? (
        <Card className="p-12 rounded-none sm:rounded-sm border-slate-200 shadow-sm text-center" data-testid="no-alerts">
          <CheckCircle size={48} weight="duotone" className="mx-auto text-emerald-600 mb-4" />
          <div className="text-xl font-bold font-heading text-slate-900">Kritik stok altı ürün yok</div>
          <div className="text-sm text-slate-600 mt-2">
            Tüm malzemeler minimum seviyenin üzerinde. Malzeme kaydında “Kritik Stok Seviyesi” alanı ile uyarı belirleyebilirsiniz.
          </div>
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((it, i) => (
            <Card key={i} data-testid={`alert-${i}`}
                  className="p-6 rounded-none sm:rounded-sm border-l-4 border-l-red-600 border-y border-r border-slate-200 shadow-sm bg-white">
              <div className="flex items-start justify-between">
                <div>
                  <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-red-600">Kritik</div>
                  <div className="text-lg font-bold text-slate-900 font-heading mt-1">{it.material_name}</div>
                </div>
                <WarningOctagon size={26} weight="fill" className="text-red-600" />
              </div>
              <div className="mt-4 grid grid-cols-2 gap-4 pt-4 border-t border-slate-200">
                <div>
                  <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-slate-500">Mevcut</div>
                  <div className="text-2xl font-black tracking-tight font-heading text-slate-900 mt-1">
                    {it.total_qty} <span className="text-sm text-slate-500">{it.unit}</span>
                  </div>
                </div>
                <div>
                  <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-slate-500">Minimum</div>
                  <div className="text-2xl font-black tracking-tight font-heading text-red-700 mt-1">
                    {it.min_stock} <span className="text-sm text-slate-500">{it.unit}</span>
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </Shell>
  );
}
